import React from "react";
import { authRoles } from "../../modules/utils/RouteAuth";

export const PollsConfigs = {
  settings: {
    layout: {
      config: {
        header: { display: true },
        footer: { display: true },
        navbar: { display: true }
      }
    }
  },
  isPrivate: true,
  auth: authRoles.team,
  routes: [
    {
      path: "/polls",
      component: React.lazy(() => import("./index"))
    }
  ]
};
